import { useState, useEffect } from "react";
import { changeLogInstanceTypes, changeLogType } from "../../../@types/components/changeLog.types";
import { Member } from "../../../@types/member.types";
import { Paycheck } from "../../../@types/paycheck.types";
import { DEPENDENT_STATUS } from "../../../constants/dependentStatus";
import ROLES from "../../../constants/roles";
import initCapitalize from "../../../utils/commonFunctions/initCapitalize";
import prefixCharacterAddition from "../../../utils/commonFunctions/prefixCharacterAddition";

import "./dependentStatusInformation.css";

const DependentStatusInformation = ({ memberInstance }: any) => {
	const [member, setMember] = useState<any>();
	const [memberStatusInformation, setMemberStatusInformation] = useState<any>();

	useEffect(() => {
		if (memberInstance)
			setMember(
				Object.assign(
					{},
					{
						...memberInstance
					}
				)
			);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [memberInstance]);

	// console.log("Log Data", member);

	useEffect(() => {
		setMemberStatusInformation(
			Object.assign(
				{},
				{
					role: member?.role,
					is_term: member?.is_term,
					dependent_status: member?.dependent_status
				}
			)
		);
	}, [member?.dependent_status, member?.is_term, member?.role]);

	return (
		<div className="dependent-status-information-container">
			<span className="member-status-text">Dependent Status: </span>
			{memberStatusInformation?.is_term && memberStatusInformation?.role === ROLES.employee ? (
				<span className="dependent-status-terminated">Employee Terminated</span>
			) : memberStatusInformation?.is_term && memberStatusInformation?.role === ROLES.dependent ? (
				<span className="dependent-status-removed">Removed</span>
			) : !memberStatusInformation?.is_term &&
			  memberStatusInformation?.role === ROLES.dependent &&
			  memberStatusInformation?.dependent_status === DEPENDENT_STATUS.active ? (
				<span className="dependent-status-active">Active</span>
			) : !memberStatusInformation?.is_term &&
			  memberStatusInformation?.role === ROLES.dependent &&
			  memberStatusInformation?.dependent_status === DEPENDENT_STATUS.inactive ? (
				<span className="dependent-status-removed">Not Yet Registered</span>
			) : null}
		</div>
	);
};

export default DependentStatusInformation;
